/**
 * @file:
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-11-16 19:10:05
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-03-28 15:50:13
 * @FilePath: /console-znzs/new_src/constant/index.js
 */
import {
    DIALOG_TYPE as O_DIALOG_TYPE,
    DISPLAY_TYPE as O_DISPLAY_TYPE,
    QUESTION_TRIGGER as O_QUESTION_TRIGGER,
    constant as old_constant,
} from '@/znzs/src/utils/enum';
import {isSandbox} from '@/znzs/new_src/utils/env';

export {TRACE_SCENE} from '@/znzs/src/utils/enum';
export {CHANNEL} from '@/znzs/src/utils/enum';

export const CHARGE_MODE = {
    ALL: 'ALL', // 全量包
    PART: 'PART', // 续费包
    PACKAGE: 'PACKAGE', // 量包
    STORAGE_PACKAGE: 'STORAGE_PACKAGE', // 存储包
};

export const CHARGE_MODE_LIST = [CHARGE_MODE.ALL, CHARGE_MODE.PART, CHARGE_MODE.PACKAGE, CHARGE_MODE.STORAGE_PACKAGE];

export const CHARGE_MODE_NAME_MAP = {
    [CHARGE_MODE.ALL]: '资源全生命周期退订',
    [CHARGE_MODE.PART]: '资源续费周期退订',
    [CHARGE_MODE.PACKAGE]: '量包退订',
    [CHARGE_MODE.STORAGE_PACKAGE]: '存储包退订',
};

/**
 * 聊天模式
 * NORMAL: 正常售后聊天
 * QF: 千帆立即咨询
 * MARKET: 千帆市场：https://qianfanmarket.baidu.com/
 * PRESALE: 售前模式
 */
export const CHAT_MODE = {
    NORMAL: 'normal',
    PRESALE: 'presale',
    QF: 'qf',
    MARKET: 'market',
    KEYUE: 'keyue',
    YIJIAN: 'yijian',
};
/**
 * 聊天模式的类型
 * ROBOT：机器人模式
 * SOCKET：走IM模式
 */
export const CHAT_MODE_TYPE = {
    ROBOT: 'robot',
    SOCKET: 'socket',
};

// 用于控制连接之后的一些行为
export const SCENE = {
    // 千帆模式，连接之后会推出表单填写的卡片
    [CHAT_MODE.QF]: 'AFTER_SALE_SP_CONSULT',
    // 千帆市场
    [CHAT_MODE.MARKET]: 'PRE_SALE',
    // 售前模式
    [CHAT_MODE.PRESALE]: 'PRE_SALE',
    // 客悦售前咨询
    [CHAT_MODE.KEYUE]: 'PRE_SALE',
    // 一见平台咨询，走售前
    [CHAT_MODE.YIJIAN]: 'PRE_SALE',
    // 售后模式
    // [CHAT_MODE.QF]: 'AFTER_SALE',
    // 游客模式
    // [CHAT_MODE.QF]: 'PRE_SALE_TOURIST',
};

export const DIALOG_TYPE = {
    ...O_DIALOG_TYPE,
    TIP: 'tip',
    IMAGE: 'image',
    SYSTEM: 'system',
    // 千帆表单
    SP_CONSULT_INFO: 'sp_consult_info',
};
export const DISPLAY_TYPE = {
    ...O_DISPLAY_TYPE,
    TIP: 'tip',
    IMAGE: 'image',
    QF_AUTHENTICATION: 'qf_authentication',
    // 千帆表单
    SP_CONSULT_INFO: 'sp_consult_info',
    MANUAL_WITH_RECOMMEND: 'manual_with_recommend', // 转人工挽留话术中增加推荐自助工具。https://console.cloud.baidu-int.com/devops/icafe/issue/wenxinqa-887/show?source=copy-shortcut
    CASCADING_FORM: 'cascading_form', // 级联表单，https://ku.baidu-int.com/d/ZkyilmuBHDhStX，https://ku.baidu-int.com/d/92d21c8bc1fb49
    ACCOUNT_CANCEL_SCENE: 'account_cancel_scene', // 账号注销场景
    RESOURCE_QUERY: 'resource_query', // 资源查询场景
    BILL_INQUIRY: 'bill_inquiry', // 账单查询场景，https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/ZXYdAhTZjt/v3byE0p5qJ/hJ9GGobyOBihAU
    INVOICE_ISSUE: 'invoice_issue', // 退款发票agent
};
export const QUESTION_TRIGGER = {
    ...O_QUESTION_TRIGGER,
    // 在cascading_form中，用户点击不同的类型
    CASCADING_FORM_KN: 'cascading_form_kn',
    CASCADING_FORM_TOOL: 'cascading_form_tool',
    SPEECH_TO_TEXT: 'speech_to_text_result',
};

export const constant = {
    [isSandbox]: {
        ...old_constant[isSandbox],
        // 实名认证链接
        authentication: 'https://qasandbox.bcetest.baidu.com/qualify/#/qualify/index',
        // 开通千帆
        createQf: 'https://qasandbox.bcetest.baidu.com/qianfan/ais/console/onlineTest',
    },
    [!isSandbox]: {
        ...old_constant[!isSandbox],
        // 实名认证链接
        authentication: 'https://console.bce.baidu.com/qualify/#/qualify/index',
        // 开通千帆
        createQf: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest',
    },
};

/**
 * 支持上传的图片
 */
export const UPLOAD_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];

export const STATUS_MAP = [
    {text: '处理中', value: 'PROCESSING'},
    {text: '待您评价', value: 'TO_BE_EVALUATED'},
    {text: '待您反馈', value: 'PENDING_FEEDBACK'},
    {text: '已完成', value: 'FINISHED'},
];
